import React from 'react';
import { Facebook, Twitter, Linkedin, Link as LinkIcon } from 'lucide-react';
import './ShareButtons.css';

const ShareButtons = ({ post, position = 'top' }) => {
  const url = `https://trinityfinancing.com/blog/${post.slug}`;
  const title = post.title;

  const handleShare = (platform) => {
    let shareUrl = '';

    switch(platform) {
      case 'facebook':
        shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
        break;
      case 'twitter':
        shareUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}&text=${encodeURIComponent(title)}`;
        break;
      case 'linkedin':
        shareUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`;
        break;
      case 'copy':
        navigator.clipboard.writeText(url);
        alert('Link copied to clipboard!');
        return;
      default:
        return;
    }

    window.open(shareUrl, '_blank', 'width=600,height=400');
  };

  return (
    <div className={`share-buttons share-buttons-${position}`}>
      <span className="share-label">Share:</span>
      <button 
        className="share-button share-facebook"
        onClick={() => handleShare('facebook')}
        aria-label="Share on Facebook"
      >
        <Facebook size={18} />
      </button>
      <button 
        className="share-button share-twitter"
        onClick={() => handleShare('twitter')}
        aria-label="Share on Twitter"
      >
        <Twitter size={18} />
      </button>
      <button 
        className="share-button share-linkedin"
        onClick={() => handleShare('linkedin')}
        aria-label="Share on LinkedIn"
      >
        <Linkedin size={18} />
      </button>
      <button 
        className="share-button share-copy"
        onClick={() => handleShare('copy')}
        aria-label="Copy link"
      >
        <LinkIcon size={18} />
      </button>
    </div>
  );
};

export default ShareButtons;